import { Download } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postStoreFileDrug, postStoreFileEquipment } from "../../../api/group";
import UploadIconParvandeh from "../../../assets/SVG/uploadIconParvandeh";

const fileTypes = ["xlsx"];

function Uploader({ equipment, setMode }) {
  // const navigate = useNavigate();

  const [file, setFile] = useState(null);
  const handleChange = (file) => {
    setFile(file);
  };
  const handleError = (err) => {
    console.log(err);
  };
  return (
    <>
      <Box mt="20px">
        <Link
          style={{
            display: "flex",
            color: "var(--emr-darkblue)",
            marginTop: "20px",
          }}
          to={
            equipment
              ? "https://statics.asar.app/equipment_sample.xlsx"
              : "https://statics.asar.app/drug_sample.xlsx"
          }
        >
          <Download size={"5"} color="blue" />
          <Typography>دانلود فایل نمونه</Typography>
        </Link>
      </Box>
      <FileUploader
        onError={handleError}
        handleChange={handleChange}
        label="فایل خود را اینجا قرار دهید"
        name="file"
        types={fileTypes}
      >
        <Box
          mt="20px"
          border={`solid 2px ${file ? "var(--emr-green)" : "#6C8C97"} `}
          borderRadius={"13px"}
          width={"calc( 100% - 40px )"}
          // height="200px"
          p="40px 20px"
          display="grid"
          justifyItems="center"
          sx={{ cursor: "pointer" }}
        >
          <Box mt="50px">
            <UploadIconParvandeh
              color={file ? "var(--emr-green)" : ""}
              size={"5"}
            />
          </Box>
          <p
            style={{
              marginTop: "50px",
              color: file ? "var(--emr-green)" : "#8B8B8B",
            }}
          >
            {file?.name || "فایل خود را اینجا بکشید یا انتخاب کنید"}
          </p>
        </Box>
      </FileUploader>
      <Box display={"flex"} justifyContent="end" mt="20px">
        <button
          style={{
            border: "none",
            color: "white",
            background: "var(--emr-primary)",
            width: "130px",
            padding: "10px 0px",
            borderRadius: "10px",
          }}
          onClick={() => {
            if (file) {
              const form = new FormData();
              form.append("file", file);
              if (equipment) {
                postStoreFileEquipment(form)
                  .then((x) => {
                    setMode("table");
                    toast.error(x[0].errorMsg);
                  })
                  .catch(() => {});
              } else {
                postStoreFileDrug(form)
                  .then((x) => {
                    setMode("table");
                    toast.error(x[0].errorMsg);
                  })
                  .catch(() => {});
              }
            }
          }}
        >
          {equipment ? "ذخیره تجهیزات" : "ذخیره دارو"}
        </button>
      </Box>
    </>
  );
}

export default Uploader;
